import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import './no_data.component.css';

const NoData = (props) => {
  return (
    <div className={`no-data-banner ${props.className ?? ''}`}>
      <FontAwesomeIcon icon={faExclamationCircle} />
      <div>
        <h6 className="title">
          {props.instrument === 'equity'
            ? `You don't have any active direct equities in your portfolio`
            : props.instrument === 'etf'
            ? `You don't have any active ETFs in your portfolio`
            : props.instrument === 'mutual_fund'
            ? `You don't have any active mutual funds in your portfolio`
            : `You don't have any active instruments in your portfolio`}
        </h6>
      </div>
    </div>
  );
};

export default NoData;
